import type { ReactNode } from 'react';

/** Signed-out frame: the form on the band, a little above centre. */
export function AuthTemplate({ children }: { children: ReactNode }) {
  return <main className="grid min-h-screen place-items-center bg-band p-4 pb-[12vh]">{children}</main>;
}
